import { forwardRef, HTMLAttributes, ReactNode } from "react";
import { Header } from "./components";
import { Footer } from "./components/Footer/footer";
import { Title } from "./components/Header/components/Title/title";
import { Main } from "./components/Main/main";
import * as SC from "./focused.styles";

export interface RootProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  fullScreen?: boolean;
}

const Root = forwardRef<HTMLDivElement, RootProps>(
  ({ children, className, style, ...props }, ref) => {
    return (
      <SC.FocusedWrapper
        ref={ref}
        className={className}
        style={style}
        {...props}
      >
        {children}
      </SC.FocusedWrapper>
    );
  }
);

Root.displayName = "Focused";

export const Focused = {
  Root,
  Footer,
  Main,
  Header,
  Title,
};
